<div class="lxm-tree-header">
    <ng-template #content></ng-template>
</div>